'use strict';

 angular.module('config', [])

.constant('ENV', 
    {
        name:'production',
        gigyaApiKey:'3_kzOlN2QEF1QU1vfBPwfdgZejm96Kr1GTd0LZHCulD8DbT_smbSMcerAHTPKvo9Wi',
        apiEndpoint:'https://proapi.zoetispetcare.com',
        tokenApiEndpoint: 'https://proproxyapi.zoetispetcare.com',
        sfmcStoriesSearchURL: 'https://sfmc-search.search.windows.net',
        sfmcStoriesSearchApiKey: 'AAE2038457A848DC4A4220AB8F2A1DB2',
        sfmcAssetsBaseUrl: 'https://sfmc.zoetispetcare.com',
        sfmcAssetsApiKey: 'vKzkCI48O0qW7hqisqfS5g==',
        contentStackProxyUrl: 'https://api.zoetispetcare.com',
        adminURL:'https://pro.zoetispetcare.com',
        proURL:'https://clinics.zoetispetcare.com',
        orderCardActivity:'410059164',
        pointConversionFactor:'10',
    }
);